import React, {Component} from 'react';
import Actionbar from "../Common/Actionbar";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faAngleUp, faAngleDown, faWallet, faPlus, faClock} from '@fortawesome/free-solid-svg-icons'
import API from "../../services/API";

const currencyFormat = Intl.NumberFormat('en-US');
class Wallet extends Component {
    state = {
        wallet_inventory: 0,
        transactions: [],
        cartItemCount : 0
    }
    render() {
        return (
            <React.Fragment>
                <Actionbar noBack={0} title='کیف پول' cartItemCount={this.state.cartItemCount} />
                <main className="container-fluid my-4 py-3">
                    <div className="row py-3  rtl  px-2 ">
                        <div className="wallet-header row">
                            <div className="col-1">

                            </div>
                            <div className="col-1">
                                <FontAwesomeIcon icon={faWallet} className="text-secondary-color text-left"/>
                            </div>
                            <div className="col-5 super-small text-color">
                                موجودی کنونی
                            </div>
                            <div className="col-5 fw-bold text-semi-big text-primary-color">
                                {

                                    currencyFormat.format(this.state.wallet_inventory)}
                                &nbsp;
                                <small>{window.localStorage.getItem("currency_unit")}</small>
                            </div>
                        </div>

                    </div>
                    <div className="earn-money-transactions px-3">
                        {
                            this.state.transactions.map(transaction=> {
                                if(transaction.decrease_amount > 0) {
                                    return(
                                        <div className="row earn-money-transaction " key={transaction.id}>
                                            <div className="col-7">
                                                <div className="transaction-title text-danger">
                                                    {transaction.description}
                                                </div>
                                                <div className="transaction-description">
                                                    <FontAwesomeIcon icon={faClock}  className='ms-2' />
                                                    {transaction.created_at}

                                                </div>
                                            </div>
                                            <div className="col-5">
                                                <div className="transaction-amount">
                                                    <FontAwesomeIcon icon={faAngleDown} className="text-danger"/>
                                                    &nbsp;
                                                    {currencyFormat.format(
                                                        transaction.decrease_amount
                                                    ) }

                                                    &nbsp;
                                                    <small>{window.localStorage.getItem("currency_unit")}</small>
                                                </div>
                                                <div className="transaction-date">

                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                else {
                                    return(
                                        <div className="row earn-money-transaction " key={transaction.id}>
                                            <div className="col-7">
                                                <div className="transaction-title text-success">
                                                    {transaction.description}
                                                </div>
                                                <div className="transaction-description">
                                                    <FontAwesomeIcon icon={faClock}  className='mr-2' />
                                                    {transaction.created_at}

                                                </div>
                                            </div>
                                            <div className="col-5">
                                                <div className="transaction-amount">
                                                    <FontAwesomeIcon icon={faAngleUp} className="text-success"/>
                                                    &nbsp;
                                                    {currencyFormat.format(
                                                        transaction.increase_amount
                                                    ) }

                                                    &nbsp;
                                                    <small>{window.localStorage.getItem("currency_unit")}</small>
                                                </div>
                                                <div className="transaction-date">

                                                </div>
                                            </div>
                                        </div>
                                    )
                                }

                            })
                        }
                    </div>

                    <div className="col-12 p-2 fixed-bottom max-w-lg">
                        <button
                            className="btn btn-primary bg-secondary-color text-right  w-100 p-2 text-semi-big pr-4"
                            onClick={() => this.props.history.push('/wallet-charge')}
                        >
                            شارژ کیف پول

                            <span className="badge  p-2 float-left">
                         <FontAwesomeIcon className="float-right"    icon={faPlus}/>
                    </span>
                        </button>
                    </div>
                </main>

            </React.Fragment>
        );
    }
    componentDidMount = () => {

        API.walletTransactions()
            .then((response) => {
                this.setState({
                    transactions: response.results.transactions,
                    wallet_inventory: response.results.wallet_inventory
                });

            })
    }
}

export default Wallet;